import { render, staticRenderFns } from "./UserOrderDialog.vue?vue&type=template&id=eefe5782&scoped=true&"
import script from "./UserOrderDialog.vue?vue&type=script&lang=js&"
export * from "./UserOrderDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserOrderDialog.vue?vue&type=style&index=0&id=eefe5782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefe5782",
  null
  
)

export default component.exports